import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CurrentVersionState {
  versionsByPlan: Record<string, string>
  setCurrentVersion: (planId: string, versionId: string) => void
  clearCurrentVersion: (planId: string) => void
}

export const useCurrentVersionStore = create<CurrentVersionState>()(
  persist(
    set => ({
      versionsByPlan: {},
      setCurrentVersion: (planId, versionId) =>
        set(state => ({
          versionsByPlan: { ...state.versionsByPlan, [planId]: versionId },
        })),
      clearCurrentVersion: planId =>
        set(state => {
          const rest = { ...state.versionsByPlan }
          delete rest[planId]
          return { versionsByPlan: rest }
        }),
    }),
    { name: 'current-version' }
  )
)
